<template>
  <section class="content">
    <add-note @response="handler($event)"></add-note>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h2 class="box-title">{{'edit_notifications' | translate}}</h2>
      </div>
      <div class="box-controls">
        <div class="row">
          <div class="col-sm-6 col-xs-12 text-center-xs">
            <button type="button" id="createNews" class="btn btn-info" data-toggle="modal" data-target="#add-note" aria-expanded="false" aria-controls="add-note"><i class="fa fa-plus-square mr-5"></i>{{'new_notification' | translate}}</button>
          </div>
          <div class="col-sm-6 col-xs-12">
            <div class="btn-group pull-right">
              <button type="button" :class="['btn btn-success btn-sm', filter === 1 ? 'active' : '']" @click="filter = '1'">{{'active' | translate}}</button>
              <button type="button" :class="['btn btn-danger btn-sm', filter === 0 ? 'active' : '']" @click="filter = '0'">{{'inactive' | translate}}</button>
              <button type="button" :class="['btn btn-info btn-sm', filter === null ? 'active' : '']" @click="filter = null">{{'all' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="box-body">
        <template v-if="loading">
          <div class="row">
            <div class="col-xs-12 text-center">
              <img class="loading-gif" src="/static/img/blabla.svg"/>
            </div>
          </div>
        </template>
        <template v-else>
          <news-table :notifications="notifications" @edit="edit($event, value)" @delete="deleteNotification($event, value)" :filter="filter"></news-table>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import NewsTable from '../../tools/Tables/NotificationsTable.vue'
import AddNote from '../../views/Monitoring/Notifications.vue'
export default {
  data () {
    return {
      notifications: [],
      alerts: [],
      value: '',
      filter: null,
      loading: true
    }
  },
  computed: {
  },
  components: {
    newsTable: NewsTable,
    addNote: AddNote
  },
  methods: {
    edit (data) {
      let alert
      data.is_active = data.is_active ? 0 : 1
      data.message = data.original_message
      API.put(`messages/${data.id}`, data)
        .then(() =>  {
          alert = {dismiss: 4, type: 'success', message: 'Update Successful', icon: 'icon fa fa-check', show: true}
          this.$store.commit('pushAlert', alert)
          this.getMessages()
        })
        .catch(error => {
          alert = {dismiss: 4, type: 'danger', message: `There was an error: ${error.body.message}`, icon: 'icon fa fa-ban', show: true}
          this.$store.commit('pushAlert', alert)
        })
    },
    getMessages () {
      this.loading = true
      this.notifications = []
      API.get('messages')
        .then(response => {
          if (typeof response.data !== 'undefined' || response.data.length !== 0) {
            response.data.forEach(note => {
              note.icon = note.status === 'info' ? 'fa fa-info-circle' : 'fa fa-warning'
              note.original_message = note.message
              note.message = note.message.split('\n')
              this.notifications.push(note)
            })
            this.loading = false
          }
        })
    },
    handler (data) {
      $('#add-note').click()
      this.alerts.push(data)
      this.getMessages()
    },
    deleteNotification (data) {
      let alert
      API.delete(`messages/${data}`)
        .then( () => {
          alert = {dismiss: 4, type: 'success', message: 'Delete Successful', icon: 'icon fa fa-check', show: true}
          this.$store.commit('pushAlert', alert)
          this.getMessages()
        })
        .catch(error => {
          alert = {dismiss: 4, type: 'danger', message: `There was an error: ${error.body.message}`, icon: 'icon fa fa-ban', show: true}
          this.$store.commit('pushAlert', alert)
        })
    }
  },
  mounted () {
    this.getMessages()
  }
}
</script>
<style>
  textarea {
    background-color: transparent;
    border-color: rgba(255,255,255,.15);
    overflow: auto;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
</style>
<style scoped>
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Monitoring/News.vue